// extracted by mini-css-extract-plugin
module.exports = {"apButton":"FastLink_apButton__1-cWh","widgetMessage":"FastLink_widgetMessage__2ThdQ","accountMessage":"FastLink_accountMessage__3LGop"};